var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassgray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FCE5B031-D9A7-4EFD-9015-F969D93E6F3B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Piggav-WEB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Min-side",
    transform: "translate(-30.000000, -78.000000)",
    fill: "#bcbcbc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "br\\xF8dsmulesti",
    transform: "translate(30.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C7.037,3 3,7.037 3,12 C3,16.963 7.037,21 12,21 C16.963,21 21,16.963 21,12 C21,7.037 16.963,3 12,3 M12,24 C5.383,24 0,18.617 0,12 C0,5.383 5.383,0 12,0 C18.617,0 24,5.383 24,12 C24,18.617 18.617,24 12,24 M11.169,12.831 C10.709,12.372 10.709,11.627 11.169,11.169 C11.627,10.709 12.373,10.709 12.832,11.168 C13.291,11.627 13.291,12.373 12.832,12.831 C12.373,13.291 11.629,13.291 11.169,12.831 M14.328,13.666 L17.45,6.799 C17.564,6.548 17.452,6.436 17.201,6.551 L10.334,9.672 C10.084,9.786 9.786,10.084 9.672,10.334 L6.55,17.201 C6.436,17.452 6.548,17.564 6.799,17.449 L13.666,14.328 C13.916,14.214 14.214,13.916 14.328,13.666",
    id: "startside"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassgray);
export default __webpack_public_path__ + "static/media/compass.gray.799440a9.svg";
export { ForwardRef as ReactComponent };